export default {
    parts: [
        'dssActionSection',
        'dssActionHeading',
        'notifyText',
        'descriptionText',
        'defaultWidth',
        'orderReceivedWidth',
        'orderShippedWidth',
        'dssActionButton',
        'dssActionButtonText',
        'backOrderDetails'
    ],
    baseStyle: (props) => ({
        dssActionSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        },
        dssActionHeading: {
            fontSize: {base: '16px', md: '20px'},
            fontWeight: '700',
            fontStyle: 'normal',
            textTransform: 'uppercase',
            lineHeight: {base: '20px', md: '24px'}
        },
        notifyText: {
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '500',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'}
        },
        descriptionText: {
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'}
        },
        dssActionButton: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            h: '48px',
            border: '1px solid gray.400',
            bg: 'white',
            textTransform: 'capitalize',
            padding: '12px',
            _hover: {bg: 'white'}
        },
        dssActionButtonText: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
            fontSize: {base: '12px', md: '14px'},
            lineHeight: '20px',
            fontWeight: '500',
            color: 'black'
        },
        policyLink: {
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'},
            width: 'fit-content',
            height: 'auto',
            textTransform: 'initial',
            backgroundColor: 'transparent',
            padding: '0',
            margin: '0',
            color: 'black',
            textDecoration: 'underline',
            marginBottom: '5px',

            _hover: {
                backgroundColor: 'transparent'
            }
        },
        backOrderDetails: {
            fontSize: {base: '14px', md: '14px'},
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: {base: '20px', md: '20px'},
            textTransform: 'initial',
            textDecoration: 'none',
            display: 'flex',
            width: {base: '100%', md: '330px'},
            maxWidth: {base: '300px', md: '330px'},
            minHeight: '44px',
            height: '44px',
            padding: '12px 24px',
            margin: {base: '0 0 36px 0', md: '0 auto 36px auto'},
            backgroundColor: '#fff',
            border: '1px solid #000',
            color: '#000',

            _hover: {
                background: '#000',
                color: '#fff',
                textDecoration: 'none'
            }
        }
    })
}